// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".underline[data-v-721d7ae4]{border-bottom:dotted;color:#e4e4e4;border-bottom-width:2px;margin-bottom:20px}[data-v-721d7ae4] .quill-editor .ql-container{height:200px}.ann[data-v-721d7ae4]{padding-left:110px;color:grey;font-size:15px}.foot[data-v-721d7ae4]{text-align:center}", ""]);
// Exports
module.exports = exports;
